export const environment = {
  production: true,
  defaultLocale: 'ru',
  offerTypes: [
    { value: 2, name: 'Предложение', parentValue: null, code: null },
    { value: 7, name: 'Проблема', parentValue: null, code: null },
    { value: 15, name: 'Шаг вперед', parentValue: null, code: null },
  ],
  offerLines: [
    { value: 1, name: 'Не знаю', parentValue: null, code: null },
    { value: 2, name: 'Да', parentValue: null, code: null },
    { value: 3, name: 'Нет', parentValue: null, code: null },
  ],
};
